import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const FilterIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <g transform="scale(2.3333333)">
        <path
          d="M 4.25,5.61 C 6.27,8.2 10,13 10,13 v 6 c 0,0.55 0.45,1 1,1 h 2 c 0.55,0 1,-0.45 1,-1 V 13 C 14,13 17.72,8.2 19.74,5.61 20.25,4.95 19.78,4 18.95,4 H 5.04 C 4.21,4 3.74,4.95 4.25,5.61 Z"
        />
      </g>
    </SvgIcon>
  );
};

export default FilterIcon;
